import { render, staticRenderFns } from "./UploadSidebar.vue?vue&type=template&id=516b36ed&scoped=true"
import script from "./UploadSidebar.vue?vue&type=script&lang=js"
export * from "./UploadSidebar.vue?vue&type=script&lang=js"
import style0 from "./UploadSidebar.vue?vue&type=style&index=0&id=516b36ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b36ed",
  null
  
)

export default component.exports